import api from '@api/index';

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async SCHEDULE_SEARCH(_, datetime) {
    const response = await api.schedule.scheduleSelect(datetime);
    return response.data.items;
  },

  SCHEDULE_SAVE(_, data) {
    return api.schedule.scheduleSave(data.schedules);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
